import { render } from "./AgendaRighe.vue?vue&type=template&id=118d7a84&scoped=true"
import script from "./AgendaRighe.vue?vue&type=script&lang=js"
export * from "./AgendaRighe.vue?vue&type=script&lang=js"

import "./AgendaRighe.vue?vue&type=style&index=0&id=118d7a84&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118d7a84"]])

export default __exports__